var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wavy-chart"},[(_vm.waiting)?_c('v-skeleton-loader',{staticStyle:{"padding":"10px 20px 0"},attrs:{"height":250,"type":"legend_wavy, image","types":{ legend_wavy: 'table-cell@2' }}}):_c('apexcharts',{ref:"wave",attrs:{"width":"800","height":"250","type":"area","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }